var map = {
	"./widget-texts_cs.json": 1433,
	"./widget-texts_da.json": 1434,
	"./widget-texts_de.json": 1435,
	"./widget-texts_en.json": 1436,
	"./widget-texts_es.json": 1437,
	"./widget-texts_fi.json": 1438,
	"./widget-texts_fr.json": 1439,
	"./widget-texts_hi.json": 1440,
	"./widget-texts_it.json": 1441,
	"./widget-texts_ja.json": 1442,
	"./widget-texts_ko.json": 1443,
	"./widget-texts_nl.json": 1444,
	"./widget-texts_no.json": 1445,
	"./widget-texts_pl.json": 1446,
	"./widget-texts_pt.json": 1447,
	"./widget-texts_ru.json": 1448,
	"./widget-texts_sv.json": 1449,
	"./widget-texts_th.json": 1450,
	"./widget-texts_tr.json": 1451
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1432;


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations ^\.\/widget\-texts_.*\.json$
// module id = 1432
// module chunks = 0 1 2 3